import { InventoryImageDTO } from "../DTO/inventoryImageDTO";

export class InventoryImage{
    public id?:number;
    public reference!:string;
    public sequenceNo?: number;
    public base64File!:string;
    public contentType?:string;
    public blob?:Blob;

    constructor(){}

    public static mapToDTO(param:InventoryImage) : InventoryImageDTO
    {
        
        let dto = new InventoryImageDTO();
        try
        {
            dto.id = param.id;
            dto.reference = param.reference;
            dto.sequenceNo = param.sequenceNo;
            dto.base64File = param.base64File;
            dto.contentType = param.contentType;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
    public static mapFromDTO(param:InventoryImageDTO) : InventoryImage
    {
        
        let obj = new InventoryImage();
        try
        {
            obj.id = param.id;
            obj.reference = param.reference;
            obj.sequenceNo = param.sequenceNo;
            obj.base64File = param.base64File;
            obj.contentType = param.contentType;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }
}